export const percentageRegex: RegExp = /^\d*(\.\d{1,2})?%$/;
